module.exports = __webpack_public_path__ + "static/img/arthroscopy-21.0da9139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-21.jpg
// module id = Wg+x
// module chunks = 52